// extracted by mini-css-extract-plugin
module.exports = {"win-card-box":"fY","winCardBox":"fY","win-card-btn-detail":"fZ","winCardBtnDetail":"fZ","win-card-dec":"f0","winCardDec":"f0","win-card-name":"f1","winCardName":"f1"};